import React, { useState } from "react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Button } from "../../ui/button";

interface Props {
  initialCanvasDimensions: { width: number; height: number };
  handleResizeCanvas: (dimensions: { width: number; height: number }) => void;
}

const TemplateCanvasDimensionsForm: React.FC<Props> = ({
  initialCanvasDimensions,
  handleResizeCanvas,
}) => {
  const [canvasDimensionsState, setCanvasDimensionsState] = useState<{
    width: number;
    height: number;
  }>(initialCanvasDimensions);

  const handleCanvasPropertiesChange = (
    e: React.ChangeEvent<HTMLInputElement> | string,
    key: string,
    value: string | number
  ) => {
    value = parseInt(value as string);
    if (isNaN(value)) return;
    if (value < 0 || value > 5000) return;

    setCanvasDimensionsState((prevSettings) => ({
      ...prevSettings,
      [key]: value,
    }));
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xs uppercase">Canvas Settings</h3>

      <div className="w-full h-full flex items-end gap-x-2 border-t border-borderColor pt-2">
        <div className="my-2 w-2/5 flex flex-col items-start">
          <Label className="block text-body mb-2 text-sm px-1">
            Canvas Width (px) *
          </Label>
          <Input
            max={5000}
            type="number"
            id={"canvasDimensions.width"}
            placeholder="100"
            value={canvasDimensionsState.width}
            className=" input-ring bg-transparent text-white placeholder"
            min={10}
            onChange={(e) => {
              handleCanvasPropertiesChange(e, "width", e.target.value);
            }}
          />
        </div>

        <div className="my-2 w-2/5 flex flex-col items-start ">
          <Label className="block text-body mb-2 text-sm px-1">
            Canvas Height (px) *
          </Label>
          <Input
            max={5000}
            type="number"
            id={"canvasDimensions.height"}
            placeholder="100"
            value={canvasDimensionsState.height}
            className="input-ring bg-transparent text-white placeholder"
            min={10}
            onChange={(e) => {
              handleCanvasPropertiesChange(e, "height", e.target.value);
            }}
          />
        </div>

        <div className="my-2 w-1/5 flex flex-col items-start ">
          <Button
            disabled={
              (canvasDimensionsState.height ===
                initialCanvasDimensions.height &&
                canvasDimensionsState.width ===
                  initialCanvasDimensions.width) ||
              canvasDimensionsState.height === 0 ||
              canvasDimensionsState.width === 0
            }
            onClick={(e) => {
              e.preventDefault();
              handleResizeCanvas({
                width: canvasDimensionsState.width,
                height: canvasDimensionsState.height,
              });
            }}
            className="w-full"
          >
            Resize Canvas
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCanvasDimensionsForm;
